export function createSecondaryRequiredWhenDistinctRefine(sameAsField, secondaryField, requiredMessage) {
    return function refineSecondaryRequiredWhenDistinct(data, ctx) {
        if (!data[sameAsField] && data[secondaryField] == null) {
            ctx.addIssue({
                code: 'custom',
                path: [secondaryField],
                message: requiredMessage,
            });
        }
    };
}
//# sourceMappingURL=create-secondary-required-when-distinct-refine.js.map